import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import app from './modules/app'
import book from './modules/book'
import order from './modules/order'

// import stations from './modules/stations'
Vue.use(Vuex)
// const modulesFiles = require.context('./modules', true, /\.js$/)
// // you do not need `import app from './modules/app'`
// // it will auto require all vuex module from modules file
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})
const store = new Vuex.Store({
  modules: {
    user,
    app,
    book,
    order
  },
  getters
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js